import Layout from '../../../common/Layout/Layout';
import { classes } from '../../../../lib/utils/cssUtils';
import { SearchBoxProps, SearchboxVariant } from './Searchbox.types';
import SearchBoxInput from './SearchBoxInput';
import { useDevice } from '../../../../lib/hooks/device';
import { groupBy } from '../../../../lib/utils/functional';
import styles from './SearchBox.module.scss';

const isVariant = (variant: string): variant is SearchboxVariant => ['basic', 'accented'].includes(variant);

const SearchBox = ({ styleVariants, ...rest }: SearchBoxProps) => {
  const device = useDevice();
  const [variants, otherStyles] = groupBy(styleVariants ?? [], isVariant);
  const verifiedVariants = variants.length > 0 ? variants : ['basic'];

  return (
    <div className={classes(styles.wrapper, ...verifiedVariants.map(variant => styles[variant]))}>
      <Layout className={styles.layout} overflow="visible">
        <div className={styles.grid}>
          <div className={styles.accent} />{' '}
          {verifiedVariants.includes('basic') || device !== 'desktop' ? (
            <>
              <div className={styles.placeholder} />
              <div className={styles.baseVariantContainer}>
                <SearchBoxInput {...rest} />
              </div>
            </>
          ) : (
            <SearchBoxInput {...rest} />
          )}
          <div className={classes({ [styles.secondaryAccent]: otherStyles.includes('right-accent') })} />
        </div>
      </Layout>
    </div>
  );
};

export default SearchBox;
